module.exports = __webpack_public_path__ + "img/square-services-bottom-left.da244f62.png";